// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__19UK1","alarm_modal":"modal_alarm_modal__1Ni0I","alarm_modal_lg":"modal_alarm_modal_lg__1-8kn","alarm_modal_bg":"modal_alarm_modal_bg__1nvxg"};